module.exports = __webpack_public_path__ + "img/shopHover.19b5cb8c.png";